import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { OperacionService } from '../../../services/operaciones/operacion/operacion.service';
import { OperacionDetalle } from '../../../models/OperacionDetalle';
import { Operacion } from '../../../models/Operacion';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-operacion-detalle',
  templateUrl: './operacion-detalle.component.html',
  styleUrls: ['./operacion-detalle.component.scss']
})
export class OperacionDetalleComponent implements OnInit {

  @Output() cerrarOperacionDetalle : EventEmitter<boolean> = new EventEmitter();
  @Input() idOperacion: number = 0 ;
  Operacion : Operacion = new Operacion();
  OperacionDetalle : OperacionDetalle;
  loading: boolean;

  tDocs:number;
  tVNPP: number;
  tAdelanto_importe: number;
  tAdelanto_Ejecutado_Importe: number;
  tAdelanto_Pendiente_Importe: number;
  tRemanente_importe: number;

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  constructor( private operacionService : OperacionService){}

  ngOnInit(){
      this.obtenerOperacionPorId();
  }

  MetcerrarOperacionDetalle(){
      this.cerrarOperacionDetalle.emit();
  }
  
  obtenerOperacionPorId(){
    this.loading = true;
    this.operacionService.ObtenerOperacionPorId(this.idOperacion).subscribe(
      res => {
        let data: any = res;
        this.Operacion = data as Operacion;
        this.OperacionDetalle = data.Detail as OperacionDetalle;
        this.tDocs = data.Detail.length;
        this.tVNPP = data.Detail.reduce((acc,obj) => acc + obj.VNPP*1,0);
        this.tAdelanto_importe = data.Detail.reduce((acc,obj) => acc + obj.Adelanto_importe*1,0);
        this.tAdelanto_Ejecutado_Importe = data.Detail.reduce((acc,obj) => acc + obj.Adelanto_Ejecutado_Importe*1,0);
        this.tAdelanto_Pendiente_Importe = data.Detail.reduce((acc,obj) => acc + obj.Adelanto_Pendiente_Importe*1,0);
        this.tRemanente_importe = data.Detail.reduce((acc,obj) => acc + obj.Remanente_importe*1,0);
        this.loading = false;
      }
    );
  }

//   obtenerOperacionDet(){
//       this.loading = true;
//       this.OperacionService.ObtenerOperacionDet(this.idOperacion).subscribe(res =>{
//           this.OperacionDetalle = res as OperacionDetalle[];
//           this.loading = false;
      
//       });
//   }
}